import ExhibitionsTableHelper from "./exhibition-table-helper";

const ExhibitionsHelpers = {
  TableMain: ExhibitionsTableHelper,
};

export default ExhibitionsHelpers;
